import { defineMessages } from "react-intl";

/**
 * Defines all of the different date formats used in our applications.
 * 
 * They are defined here because each language has their own preferred format for dates and this allows us to easily define one for each locale.
 */
const DateFormat = defineMessages({
  shortDate: {
    id: "shortDateFormat",
    defaultMessage: "MM/dd/yyyy"
  },

  mediumDate: {
    id: "mediumDateFormat",
    defaultMessage: "MMM dd, yyyy"
  },

  longDate: {
    id: "longDateFormat",
    defaultMessage: "MMMM dd, yyyy"
  },

  shortDatetime: {
    id: "shortDatetimeFormat",
    defaultMessage: "MM/dd/yyyy h:mm a"
  },

  mediumDatetime: {
    id: "mediumDatetimeFormat",
    defaultMessage: "MMM dd, yyyy h:mm a"
  },

  longDatetime: {
    id: "longDatetimeFormat",
    defaultMessage: "MMMM dd, yyyy h:mm a"
  },

  time: {
    id: "timeFormat",
    defaultMessage: "H:mm"
  },
});

export default DateFormat;
